import {
  CmpRoute_default
} from "./chunk-APVU6VCQ.js";

// src/Cmp/Cmp.ts
import axios from "axios";
var AesirxCmpApiService = class {
  constructor() {
    this.route = null;
    this.getConsentsTemplate = async (domain, time_start) => {
      try {
        const data = await this.route.getConsentsTemplate(domain, time_start);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.updateConsentsTemplate = async (dataForm) => {
      try {
        const data = await this.route.updateConsentsTemplate(dataForm);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.getIDVerification = async (domain) => {
      try {
        const data = await this.route.getIDVerification(domain);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.updateIDVerification = async (dataForm) => {
      try {
        const data = await this.route.updateIDVerification(dataForm);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.getUserList = async () => {
      try {
        const data = await this.route.getUserList();
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.getUserDetail = async (id) => {
      try {
        const data = await this.route.getUserDetail(id);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.createUser = async (dataForm) => {
      try {
        const data = await this.route.createUser(dataForm);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.updateUser = async (dataForm) => {
      try {
        const data = await this.route.updateUser(dataForm);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.deleteUser = async (ids) => {
      try {
        const data = await this.route.deleteUser(ids);
        let results = null;
        if (data) {
          results = data;
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancle" };
        } else
          throw error;
      }
    };
    this.route = new CmpRoute_default();
  }
};

export {
  AesirxCmpApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
